<button
  [attr.aria-describedby]="id"
  [attr.aria-label]="ariaLabel"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
>
  <img src="/assets/images/icons/{{ icon }}" #tooltipIcon alt="" />
  <div [id]="id" class="tooltip {{ position }}" role="tooltip" #tooltip>
    <ng-content></ng-content>
  </div>
</button>
